/* Cake Miami — privacy-safe public reviewer name formatter.
   Shared by every storefront review/UGC surface (PDP + Shop All) so the name
   parsing lives in ONE place instead of being duplicated per script.

   Rule (privacy-forward, intentionally simple):
   - Trim + collapse whitespace.
   - 2+ name tokens  -> "First L."  (title-cased first name + uppercased last initial + ".")
   - 1 token         -> "First"     (title-cased, so casing is consistent across reviews)
   - empty/unusable  -> fallback (defaults to "Cake Miami customer")

   Title-casing the first name and uppercasing the last initial means the output
   looks consistent no matter how the customer typed it (ASHLEY / ashley -> Ashley).
   Diacritics are preserved (toUpperCase/toLowerCase keep é, ñ, etc.).
   Idempotent: "Ashley W." -> "Ashley W."

   See docs/2026-06-07_ugc_reviews_tweaks.md (Decision 1). */
window.transformReviewName = window.transformReviewName || function (raw, fallback) {
  var fb = fallback === undefined ? 'Cake Miami customer' : fallback;
  var s = String(raw == null ? '' : raw).replace(/\s+/g, ' ').trim();
  if (!s) return fb;
  var tokens = s.split(' ');
  function titleCase(w) {
    return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
  }
  if (tokens.length === 1) return titleCase(tokens[0]);
  var first = titleCase(tokens[0]);
  var lastInitial = tokens[tokens.length - 1].charAt(0).toUpperCase();
  return first + ' ' + lastInitial + '.';
};
